module.exports = __webpack_public_path__ + "img/email.41893e4d.svg";